export const environment = {
  name: 'PROD',
	production: true,
	inmem: false,
	useMsal: true,
  msalConfig: {
    auth: {
      clientId: '229110fe-6acd-4609-8f93-2ea6b5cd7d05',
      authority: 'https://login.microsoftonline.com/c990bb7a-51f4-439b-bd36-9c07fb1041c0',
      redirectUri: 'https://www.fiesta.ford.com'
    },
    cache: {
      cacheLocation: 'sessionStorage',
      storeAuthStateInCookie: false
    }
  },
  apiConfig: {
    scopes: ['api://b51b8083-b856-4666-9ca6-78021a2f2a54/.default'],
    uri: 'https://api.fordcredit.com/fiesta/api/v2'
  }
};